var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "navigation-top",
      class: { "navigation-top--index": _vm.isIndex },
      attrs: { role: "navigation", "aria-label": "Top navigation" },
    },
    [
      _c(
        "ul",
        { staticClass: "navigation-top__list" },
        _vm._l(_vm.data, function (item, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "navigation-top__item",
              class: { "is-active": item.active },
            },
            [
              _c("z-icon", {
                staticClass: "navigation-top__icon",
                attrs: { name: item.params.ICON__NAME },
              }),
              _vm._v(" "),
              _c("a", {
                attrs: { href: item.link, title: item.name },
                domProps: { innerHTML: _vm._s(item.name) },
              }),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }